import { useMutation, useQueryClient } from '@tanstack/react-query';

import { patchReitDemandLetterAcknowledgement } from '@arrived/api_v2';
import { TaxDocumentList, TaxYearRequest } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { supplementalDataKeyFn, taxDocumentKeyFn, taxDocumentsKeyFn } from './taxDocuments.keys';

export function usePatchTaxYearMutation(options?: UseMutationOptions<TaxDocumentList, TaxYearRequest>) {
  const queryClient = useQueryClient();

  return useMutation((request) => patchReitDemandLetterAcknowledgement(request), {
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(taxDocumentsKeyFn(variables.accountId));
      queryClient.invalidateQueries(taxDocumentKeyFn(variables.accountId, variables.year));
      queryClient.invalidateQueries(supplementalDataKeyFn(variables.accountId, variables.year));

      options?.onSuccess?.(data, variables, context);
    },
  });
}
